// extracted by mini-css-extract-plugin
export default {"wrapper":"social-skeletons-ShelfItemsLoadingSkeleton__wrapper--31PnO"};